import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
const initial: any = {
  list: [],
  markForRemove: [],
  anchorFields: {
    active: false,
    chapter: null,
    activity: null,
    subactivity: null,
  }
};

export const linesSlice = createSlice({
  name: "lines",
  initialState: { ...initial },
  reducers: {
    addLine: (state, action) => {
      state.list = [...state.list, action.payload] as any;

    },
    removeLine: (state, action) => {
      const currentLines: any = [...state.list];
      const lineRemoved = currentLines.filter(
        (el: any) => el.index !== action.payload.index
      );

      state.list = [...lineRemoved] as any;
      if (action.payload.idLinea) state.markForRemove = [...state.markForRemove, action.payload.idLinea]
    },
    updateLine: (state, action) => {
      const currentLines: any = [...current(state).list];
      const updateIndex = currentLines.findIndex(
        (l: any) => l.index === action.payload.index
      );
      currentLines[updateIndex] = { ...action.payload };
      state.list = [...currentLines] as any;
    },
    resetLines: (state) => {
      state.markForRemove = [];
      state.list = [] as any;
      state.anchorFields = {
        active: false,
        chapter: null,
        activity: null,
        subactivity: null,
      }
    },
    resetMarkForRemove: (state) => {
      state.markForRemove = [];
    },
    switchAnchorFields: (state, action: PayloadAction<boolean>) => {
      state.anchorFields.active = action.payload;
    },
    setAnchorFields: (state, action: PayloadAction<{ chapter?: any, activity?: any, subactivity?: any }>) => {
      state.anchorFields = {
        ...state.anchorFields,
        chapter: action.payload.chapter ?? state.anchorFields.chapter,
        activity: action.payload.activity ?? state.anchorFields.activity,
        subactivity: action.payload.subactivity ?? state.anchorFields.subactivity,
      };
    },
    resetAnchorFields: (state) => {
      state.anchorFields = {
        chapter: null,
        activity: null,
        subactivity: null,
      };
    },
  },
});

export default linesSlice.reducer;
export const { addLine, updateLine, removeLine, resetLines, resetMarkForRemove, switchAnchorFields, setAnchorFields, resetAnchorFields } =
  linesSlice.actions;
